import { style } from "@angular/animations";

let smallCol: string = "smallCol ";
let midCol: string = "midCol ";
let largeCol: string = "largeCol ";
let extraLargeCol: string = "extraLargeCol ";

let activoProperty = {
  label: "Activo",
  type: "select",
  selectorConf: {
    fields: ["labelActivo"],
    id: "idActivo",
    dataList: [
      { idActivo: "Y", labelActivo: "Si" },
      { idActivo: "N", labelActivo: "No" },
    ],
  },
  filterValue: "activo",
  size: smallCol,
};

let emptyProperty = {
  label: "",
  type: "empty",
  filterValue: "",
  size: "xsColButton",
};

let observacionesProperty = {
  label: "Observaciones",
  type: "text",
  filterValue: "observaciones",
  size: largeCol,
  hide: false,
};

let filterOutTableHidden = {
  label: "",
  type: "text",
  filterValue: "",
  size: largeCol,
  hide: true,
};

let propertyFechasPet = {
  label: "Fec. solicitud",
  type: "date",
  filterValue: "peticionDesde",
  size: midCol,
  multiple: true,
  secondField: {
    filterValue: "peticionHasta",
    size: midCol,
    value: "",
  },
};
let propertyfechasRealiz = {
  label: "Fec. tramitación",
  type: "date",
  filterValue: "fechaEstadoDesde",
  size: midCol,
  multiple: true,
  secondField: {
    filterValue: "fechaEstadoHasta",
    size: midCol,
    value: "",
  },
};

let columnaNotaStyle = {
  "min-width": "156px",
  "max-width": "156px",
  width: "156px",
};

export const FilterConstants = {
  concessionaire: [
    {
      label: "Identificador",
      type: "text",
      filterValue: "identificador",
      size: midCol,
    },
    {
      label: "Nombre",
      type: "text",
      filterValue: "nombre",
      size: extraLargeCol,
    },
    activoProperty,
    {
      label: "Región",
      type: "text",
      filterValue: "region",
      size: midCol,
    },
  ],

  maintenanceUser: [
    {
      label: "Identificador",
      type: "text",
      filterValue: "identificador",
      size: smallCol,
    },
    {
      label: "Nombre",
      type: "text",
      filterValue: "nombre",
      size: midCol,
    },
    {
      label: "Apellido 1",
      type: "text",
      filterValue: "apellido1",
      size: midCol,
    },
    {
      label: "Apellido 2",
      type: "text",
      filterValue: "apellido2",
      size: midCol,
    },
    {
      label: "Email",
      type: "text",
      filterValue: "email",
      size: midCol,
    },
    {
      label: "Perfil",
      type: "select",
      selectorConf: {
        fields: ["peId", "peDesc"],
        id: "peId",
        dataList: [],
      },
      filterValue: "perfil",
      size: midCol,
    },
    {
      label: "Concesionario",
      type: "select",
      selectorConf: {
        fields: ["coId", "coNombre"],
        id: "coId",
        dataList: [],
      },
      filterValue: "concesionario",
      size: largeCol,
    },
    activoProperty,
    {
      label: "Bloqueado",
      type: "select",
      selectorConf: {
        fields: ["labelBloqueado"],
        id: "idBloqueado",
        dataList: [
          { idBloqueado: "Y", labelBloqueado: "Si" },
          { idBloqueado: "N", labelBloqueado: "No" },
        ],
      },
      filterValue: "bloqueado",
      size: smallCol,
    },
    {
      label: "Región concesionario",
      type: "text",
      filterValue: "region",
      size: largeCol,
    },
  ],
  maintenanceHistoricoBastidor: [
    {
      label: "Bastidor",
      type: "text",
      filterValue: "bastidor",
      size: largeCol,
    },
    {
      label: "Fecha alta",
      type: "date",
      filterValue: "fechaInicio",
      size: smallCol,
      multiple: true,
      secondField: {
        filterValue: "fechaFin",

        value: "",
      },
    },
    {
      label: "Imagen placa",
      type: "text",
      filterValue: "imgPlaca",
      size: smallCol,
      style: { 'text-wrap': 'nowrap' },
    },
    {
      label: "Tipo",
      type: "text",
      filterValue: "tipo",
      size: smallCol,
    },
    {
      label: "Variante",
      type: "text",
      filterValue: "variante",
      size: midCol,
    },
    {
      label: "Versión",
      type: "text",
      filterValue: "version",
      size: largeCol,
    },
    {
      label: "Contraseña",
      type: "text",
      filterValue: "password",
      size: largeCol,
    },
    {
      label: "Emisiones",
      type: "text",
      filterValue: "emisiones",
      size: midCol,
    },
  ],

  patronWltp: [
    {
      label: "Tipo",
      type: "text",
      filterValue: "tipo",
      size: largeCol,
    },
    {
      label: "Motor",
      type: "text",
      filterValue: "motor",
      size: largeCol,
    },
    {
      label: "Cambio",
      type: "text",
      filterValue: "cambio",
      size: largeCol,
    },
    {
      label: "Correlativo",
      type: "text",
      filterValue: "correlativo",
      size: largeCol,
    },
  ],

  ayudasGenerales: [
    {
      label: "Fichero",
      type: "text",
      filterValue: "ayFichero",
    },
    {
      label: "Titulo",
      type: "text",
      filterValue: "ayTitulo",
    },
  ],

  types: {
    "2": "number",
    "12": "text",
    "93": "date",
    "2004": "blob",
    "1": "textArea",
  },

  typesToNumber: {
    number: "2",
    text: "12",
    date: "93",
    dateAux: "93",
    blob: "2004",
    textArea: "1",
  },
  templates: [
    {
      label: "Identificador",
      type: "text",
      filterValue: "identificador",
      size: largeCol,
    },
    {
      label: "Descripción",
      type: "text",
      filterValue: "descripcion",
      size: midCol,
    },
  ],

  printsRules: [
    {
      label: "",
      type: "",
      filterValue: "",
      style: {
        "min-width": "26px",
        "width": "26px",
        "max-width": "26px"
      }
    },
    {
      label: "",
      type: "",
      filterValue: "",
      style: {
        "min-width": "40px",
        "width": "40px",
        "max-width": "40px"
      }
    },
    {
      label: "",
      type: "",
      filterValue: "",
      style: {
        "min-width": "40px",
        "width": "40px",
        "max-width": "40px"
      }
    },
    {
      label: "Indice",
      type: "text",
      filterValue: "indice",
      size: smallCol,
    },
    {
      label: "Tipo Placa",
      type: "select",
      selectorConf: {
        fields: ["teDescr"],
        id: "teId",
        dataList: [{teId: "F", teDescr: "FABRICANTE"}, {teId: "P", teDescr: "PARABRISAS"}, {teId: "A", teDescr: "AMBOS"}],
      },
      filterValue: "tipoPlaca",
      size: midCol,
    },
    {
      label: "Tipo Etiqueta",
      type: "text",
      filterValue: "tipoEtiqueta",
      size: midCol,
    },
    {
      label: "Marca",
      type: "select",
      selectorConf: {
        fields: ["marcaDescr"],
        id: "marcaId",
        dataList: [
          {marcaId: "AU", marcaDescr: "AUDI"},
          {marcaId: "CU", marcaDescr: "CUPRA"},
          {marcaId: "SE", marcaDescr: "SEAT"},
          {marcaId: "SK", marcaDescr: "SKODA"},
          {marcaId: "VW", marcaDescr: "VOLKSWAGEN"}
        ],
      },
      filterValue: "marca",
      size: smallCol,
    },
    {
      label: "Tipo Homol.",
      type: "text",
      filterValue: "tipoHomologado",
      size: largeCol,
    },
    {
      label: "Formato Imp.",
      type: "text",
      filterValue: "formatoImpresion",
      size: largeCol,
    },
  ],

  dataCDT: [
    {
      label: "Tipo",
      type: "text",
      filterValue: "tipo",
      size: largeCol,
    },
    {
      label: "Variante",
      type: "text",
      filterValue: "variante",
      size: largeCol,
    },
    {
      label: "Versión",
      type: "text",
      filterValue: "version",
      size: largeCol,
    },
    {
      label: "Contraseña",
      type: "text",
      filterValue: "password",
      size: largeCol,
    },
  ],

  availableFieldsRoyalDecree: [
    {
      label: "Identificador",
      type: "text",
      filterValue: "identificador",
      size: smallCol,
    },
    {
      label: "Texto",
      type: "text",
      filterValue: "descripcion",
      size: extraLargeCol,
    },
    {
      label: "Tipo",
      type: "text",
      filterValue: "tipo",
      size: largeCol,
    },
    {
      label: "Longitud máxima",
      type: "text",
      filterValue: "longitud",
      size: smallCol,
    },
  ],

  certificatesMailBox: [
    {
      label: "Número de solicitud",
      type: "text",
      filterValue: "solicitud",
      size: midCol,
    },
    {
      label: "Bastidor",
      type: "text",
      filterValue: "bastidor",
      size: largeCol,
    },
    {
      label: "Matrícula",
      type: "text",
      filterValue: "matricula",
      size: smallCol,
    },
    {
      label: "Certificado",
      type: "select",
      selectorConf: {
        fields: ["tcId", "tcDescr"],
        id: "tcId",
        dataList: [],
      },
      filterValue: "certificado",
      size: smallCol,
    },
    {
      label: "Fec. solicitud",
      type: "date",
      filterValue: "peticionDesde",
      size: midCol,
      multiple: true,
      secondField: {
        filterValue: "peticionHasta",
        size: midCol,
        value: "",
      },
    },
    {
      label: "Analista",
      type: "select",
      selectorConf: {
        fields: ["usuarioId", "nombre"],
        id: "usuarioId",
        dataList: [],
      },
      filterValue: "analista",
      size: smallCol,
    },
    {
      label: "Estado",
      type: "select",
      selectorConf: {
        fields: ["esId", "esDescr"],
        id: "esId",
        dataList: [],
      },
      filterValue: "estado",
      size: "xsCol ",
    },
    {
      label: "Nota",
      type: "text",
      filterValue: "comentario",
      style: columnaNotaStyle,
    },
    emptyProperty,
  ],

  cocMailBox: [
    {
      label: "Número de solicitud",
      type: "text",
      filterValue: "solicitud",
      size: midCol,
    },
    {
      label: "Bastidor",
      type: "text",
      filterValue: "bastidor",
      size: largeCol,
    },
    {
      label: "Tipo solicitud",
      filterValue: "tipoCoc",
      type: "select",
      selectorConf: {
        fields: ["tcId", "tcDescr"],
        id: "tcId",
        dataList: [],
      },
      size: smallCol,
    },
    {
      label: "Fec. solicitud",
      type: "date",
      filterValue: "peticionDesde",
      size: smallCol,
      multiple: true,
      secondField: {
        filterValue: "peticionHasta",
        size: smallCol,
        value: "",
      },
    },
    {
      label: "Analista",
      type: "select",
      selectorConf: {
        fields: ["usuarioId", "nombre"],
        id: "usuarioId",
        dataList: [],
      },
      filterValue: "analista",
      size: smallCol,
    },
    {
      label: "Estado",
      type: "select",
      selectorConf: {
        fields: ["esId", "esDescr"],
        id: "esId",
        dataList: [],
      },
      filterValue: "estado",
      size: "xsCol ",
    },
    {
      label: "Nota",
      type: "text",
      filterValue: "nota",
      style: columnaNotaStyle,
    },
    emptyProperty,
  ],

  placaMailBox: [
    {
      label: "Número de solicitud",
      type: "text",
      filterValue: "solicitud",
      size: midCol,
    },
    {
      label: "Bastidor",
      type: "text",
      filterValue: "bastidor",
      size: largeCol,
    },
    {
      label: "Importador",
      type: "text",
      filterValue: "importador",
      size: smallCol,
    },
    {
      label: "Tipo solicitud",
      filterValue: "certificado",
      type: "select",
      selectorConf: {
        fields: ["tcId", "tcDescr"],
        id: "tcId",
        dataList: [],
      },
      size: smallCol,
    },
    {
      label: "Fec. solicitud",
      type: "date",
      filterValue: "peticionDesde",
      size: smallCol,
      multiple: true,
      secondField: {
        filterValue: "peticionHasta",
        size: smallCol,
        value: "",
      },
    },
    {
      label: "Analista",
      type: "select",
      selectorConf: {
        fields: ["usuarioId", "nombre"],
        id: "usuarioId",
        dataList: [],
      },
      filterValue: "analista",
      size: "xsCol ",
    },
    {
      label: "Estado",
      type: "select",
      selectorConf: {
        fields: ["esId", "esDescr"],
        id: "esId",
        dataList: [],
      },
      filterValue: "estado",
      size: "xsCol ",
    },
    {
      label: "Nota",
      type: "text",
      filterValue: "comentario",
      style: columnaNotaStyle,
    },
    emptyProperty,
  ],

  certificatesMailBoxOutTable: [
    {
      label: "Marca",
      type: "select",
      selectorConf: {
        fields: ["maId", "maDescr"],
        id: "maId",
        dataList: [],
      },
      filterValue: "marca",
      size: largeCol,
      hide: false,
    },
    {
      label: "Región",
      type: "text",
      filterValue: "region",
      size: largeCol,
      hide: false,
    },
    {
      label: "Reforma",
      type: "select",
      selectorConf: {
        fields: ["reId", "reDescr"],
        id: "reId",
        dataList: [],
      },
      filterValue: "reforma",
      size: largeCol,
      hide: false,
    },
    {
      label: "Tipo homologado",
      type: "select",
      selectorConf: {
        fields: ["valorTipoVehiculo"],
        id: "valorTipoVehiculo",
        dataList: [],
      },
      filterValue: "tipoVehiculo",
      size: largeCol,
      hide: false,
    },
    {
      label: "Plantilla utilizada",
      type: "select",
      selectorConf: {
        fields: ["paId"],
        id: "paId",
        dataList: [],
      },
      filterValue: "plantilla",
      size: largeCol,
      hide: false,
    },
    observacionesProperty,
  ],

  cocMailBoxOutTable: [
    {
      label: "Marca",
      type: "select",
      selectorConf: {
        fields: ["maId", "maDescr"],
        id: "maId",
        dataList: [],
      },
      filterValue: "marca",
      size: largeCol,
      hide: false,
    },
    {
      label: "Región",
      type: "text",
      filterValue: "region",
      size: largeCol,
      hide: false,
    },
    {
      label: "Tipo homologado",
      type: "select",
      selectorConf: {
        fields: ["valorTipoVehiculo"],
        id: "valorTipoVehiculo",
        dataList: [],
      },
      filterValue: "tipoVehiculo",
      size: largeCol,
      hide: false,
    },
    observacionesProperty,
    filterOutTableHidden,
  ],

  placaOutTable: [
    {
      label: "Marca",
      type: "select",
      selectorConf: {
        fields: ["maId", "maDescr"],
        id: "maId",
        dataList: [],
      },
      filterValue: "marca",
      size: largeCol,
      hide: false,
    },
    {
      label: "Tipo homologado",
      type: "select",
      selectorConf: {
        fields: ["valorTipoVehiculo"],
        id: "valorTipoVehiculo",
        dataList: [],
      },
      filterValue: "tipoVehiculo",
      size: largeCol,
      hide: false,
    },
    {
      label: "Motor",
      type: "select",
      selectorConf: {
        fields: ["valorMotor"],
        id: "valorMotor",
        dataList: [],
      },
      filterValue: "motor",
      size: largeCol,
      hide: false,
    },
    {
      label: "Tipo de placa",
      type: "select",
      selectorConf: {
        fields: ["ValorPlaca", "TipoPlaca"],
        id: "ValorPlaca",
        dataList: [],
      },
      filterValue: "tipoPlaca",
      size: largeCol,
      hide: false,
    },
    {
      label: "Motivo reedición",
      type: "select",
      selectorConf: {
        fields: ["mrId", "mrDesc"],
        id: "mrId",
        dataList: [],
      },
      filterValue: "motivo",
      size: largeCol,
      hide: false,
    },
    observacionesProperty,
  ],

  certificatesQuery: [
    {
      label: "Número de solicitud",
      type: "text",
      filterValue: "solicitud",
      size: midCol,
    },
    {
      label: "Bastidor",
      type: "text",
      filterValue: "bastidor",
      size: largeCol,
    },
    {
      label: "Matrícula",
      type: "text",
      filterValue: "matricula",
      size: smallCol,
    },
    {
      label: "Certificado",
      type: "select",
      selectorConf: {
        fields: ["tcId", "tcDescr"],
        id: "tcId",
        dataList: [],
      },
      filterValue: "certificado",
      size: smallCol,
    },
    {
      label: "Fec. solicitud",
      type: "date",
      filterValue: "peticionDesde",
      size: smallCol,
      multiple: true,
      secondField: {
        filterValue: "peticionHasta",
        size: smallCol,
        value: "",
      },
    },
    {
      label: "Fec. tramitación",
      type: "date",
      filterValue: "fechaEstadoDesde",
      size: smallCol,
      multiple: true,
      secondField: {
        filterValue: "fechaEstadoHasta",
        size: smallCol,
        value: "",
      },
    },
    {
      label: "Analista",
      type: "select",
      selectorConf: {
        fields: ["usuarioId", "nombre"],
        id: "usuarioId",
        dataList: [],
      },
      filterValue: "analista",
      size: smallCol,
    },
    {
      label: "Estado",
      type: "select",
      selectorConf: {
        fields: ["esId", "esDescr"],
        id: "esId",
        dataList: [],
      },
      filterValue: "estado",
      size: "xsCol ",
    },
    {
      label: "Nota",
      type: "text",
      filterValue: "comentario",
      style: columnaNotaStyle,
    },
  ],
  placaQuery: [
    {
      label: "Número de solicitud",
      type: "text",
      filterValue: "solicitud",
      size: largeCol,
    },
    {
      label: "Bastidor",
      type: "text",
      filterValue: "bastidor",
      size: largeCol,
    },
    {
      label: "Importador",
      type: "text",
      filterValue: "importador",
      size: midCol,
    },
    {
      label: "Tipo solicitud",
      type: "select",
      selectorConf: {
        fields: ["tcId", "tcDescr"],
        id: "tcId",
        dataList: [],
      },
      filterValue: "certificado",
      size: midCol,
    },
    propertyFechasPet,
    propertyfechasRealiz,
    {
      label: "Analista",
      type: "select",
      selectorConf: {
        fields: ["usuarioId", "nombre"],
        id: "usuarioId",
        dataList: [],
      },
      filterValue: "analista",
      size: smallCol,
    },
    {
      label: "Estado",
      type: "select",
      selectorConf: {
        fields: ["esId", "esDescr"],
        id: "esId",
        dataList: [],
      },
      filterValue: "estado",
      size: smallCol,
    },
    {
      label: "Nota",
      type: "text",
      filterValue: "comentario",
      style: columnaNotaStyle,
    },
  ],

  placaQueryFiles: [
    {
      label: "Fecha",
      type: "date",
      filterValue: "fechaInicio",
      size: largeCol,
      multiple: true,
      secondField: {
        filterValue: "fechaFin",
        size: largeCol,
        value: "",
      },
    },
    {
      label: "Analista",
      type: "select",
      selectorConf: {
        fields: ["usuarioId", "nombre"],
        id: "usuarioId",
        dataList: [],
      },
      filterValue: "analista",
      size: largeCol,
    },
    {
      label: "Impresión",
      type: "",
      filterValue: "",
      size: largeCol,
    },
    {
      label: "",
      type: "empty",
      filterValue: "",
      size: largeCol,
    },
  ],
  cocQuery: [
    {
      label: "Número de solicitud",
      type: "text",
      filterValue: "solicitud",
      size: largeCol,
    },
    {
      label: "Bastidor",
      type: "text",
      filterValue: "bastidor",
      size: largeCol,
    },
    {
      label: "Tipo solicitud",
      filterValue: "tipoCoc",
      type: "select",
      selectorConf: {
        fields: ["tcId", "tcDescr"],
        id: "tcId",
        dataList: [],
      },
      size: midCol,
    },
    propertyFechasPet,
    propertyfechasRealiz,
    {
      label: "Analista",
      type: "select",
      selectorConf: {
        fields: ["usuarioId", "nombre"],
        id: "usuarioId",
        dataList: [],
      },
      filterValue: "analista",
      size: smallCol,
    },
    {
      label: "Estado",
      type: "select",
      selectorConf: {
        fields: ["esId", "esDescr"],
        id: "esId",
        dataList: [],
      },
      filterValue: "estado",
      size: "xsCol",
    },
    {
      label: "Nota",
      type: "text",
      filterValue: "nota",
      style: columnaNotaStyle,
    },
  ],
  fsPlacaOuttable: [
    {
      label: "PR1",
      type: "text",
      filterValue: "pr1",
      size: smallCol,
    },
    {
      label: "PR2",
      type: "text",
      filterValue: "pr2",
      size: smallCol,
    },
    {
      label: "PR3",
      type: "text",
      filterValue: "pr3",
      size: smallCol,
    },
    {
      label: "PR4",
      type: "text",
      filterValue: "pr4",
      size: smallCol,
    },
    {
      label: "PR5",
      type: "text",
      filterValue: "pr5",
      size: smallCol,
    },
    {
      label: "PR6",
      type: "text",
      filterValue: "pr6",
      size: smallCol,
    },
    {
      label: "PR7",
      type: "text",
      filterValue: "pr7",
      size: smallCol,
    },
    {
      label: "PR8",
      type: "text",
      filterValue: "pr8",
      size: smallCol,
    },
    {
      label: "PR9",
      type: "text",
      filterValue: "pr9",
      size: smallCol,
    },
    {
      label: "PR10",
      type: "text",
      filterValue: "pr10",
      size: smallCol,
    },
  ],
  fsPlaca: [
    {
      label: "MY",
      type: "text",
      filterValue: "my",
      size: smallCol,
    },
    {
      label: "MOD",
      type: "text",
      filterValue: "mod",
      size: smallCol,
    },
    {
      label: "PLACA",
      type: "text",
      filterValue: "placa",
      size: smallCol,
    },
    {
      label: "Combinacion PR'S",
      type: "",
      filterValue: "",
      style: {
        "min-width": "550px",
        "max-width": "550px",
        width: "550px",
      },
    },
    {
      label: "S.INIC",
      type: "",
      filterValue: "",
      size: smallCol,
    },
    {
      label: "S.FIN",
      type: "",
      filterValue: "",
      size: smallCol,
    },
  ],
};
